import { ReactNode } from 'react';
import { Box, Paper } from '@mui/material';

export interface FilterBarProps {
  children: ReactNode;
}

/**
 * Wrapper responsivo para barra de filtros.
 * Filhos quebram para nova linha em ecrãs pequenos e alinham com gap consistente.
 */
export default function FilterBar({ children }: FilterBarProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'center',
          '& > *': { minWidth: 180, flex: '1 1 180px' },
          '& > *:first-of-type': { flex: '2 1 260px' },
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}
